import { TmBaseComponent } from '@treasury/presentation';
import { circleCloseIcon, plusIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-button';
// eslint-disable-next-line no-duplicate-imports
import { TmButton } from '@treasury/presentation/components/tm-button';
import '@treasury/presentation/components/tm-context-menu';
import '@treasury/presentation/components/tm-icon';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

export const tagName = 'add-account-group-menu';

@customElement(tagName)
export class AddAccountGroupMenu extends TmBaseComponent {
    @state()
    private groupName = '';

    @state()
    private button?: TmButton;

    protected render() {
        return html` <tm-context-menu
            .openOn=${'click'}
            .closeOn=${'createGroup'}
            .overlayClass=${'overrideDefault'}
            .items=${[{ component: this.createMenu() }]}
            ><tm-button importance="tertiary"
                ><tm-icon .icon=${plusIcon} color="#fff"></tm-icon></tm-button
        ></tm-context-menu>`;
    }

    private createMenu() {
        const wrapper = document.createElement('div');
        wrapper.classList.add('px-4', 'py-4');
        wrapper.appendChild(this.createHeader());
        wrapper.appendChild(this.createInput());
        wrapper.appendChild(this.createFooter());
        return wrapper;
    }

    private createHeader() {
        const header = document.createElement('div');
        const titleEl = document.createElement('span');
        const closeEl = document.createElement('tm-icon');
        closeEl.icon = circleCloseIcon;
        closeEl.color = '#70757A';
        closeEl.addEventListener('click', () => {
            closeEl.dispatchEvent(
                new CustomEvent('createGroup', {
                    bubbles: true,
                    composed: true,
                })
            );
        });
        titleEl.innerHTML = 'Create account group';
        header.classList.add(
            'text-secondary',
            'text-lg',
            'font-medium',
            'pb-2',
            'flex',
            'items-center',
            'justify-between'
        );
        header.appendChild(titleEl);
        header.appendChild(closeEl);
        return header;
    }

    private createInput() {
        const input = document.createElement('tm-text-field');
        input.label = 'Group name';
        input.required = true;
        input.addEventListener('value-changed', () => {
            this.groupName = input.value || '';
            if (this.button) {
                this.button.disabled = !this.groupName;
            }
        });
        return input;
    }

    private createFooter() {
        const footer = document.createElement('div');
        footer.classList.add('flex', 'justify-center', 'py-3');
        const button = document.createElement('tm-button');
        button.importance = 'primary';
        button.innerHTML = 'Create group';
        this.button = button;

        button.addEventListener('click', () => {
            button.dispatchEvent(
                new CustomEvent('createGroup', {
                    detail: this.groupName,
                    bubbles: true,
                    composed: true,
                })
            );
            this.dispatchEvent(
                new CustomEvent('createGroup', {
                    detail: this.groupName,
                    bubbles: true,
                    composed: true,
                })
            );
            this.groupName = '';
        });
        footer.appendChild(button);
        return footer;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: AddAccountGroupMenu;
    }
}
